import { Link } from 'react-router-dom';
import { ArrowRight, Heart, Check, FileText, Timer, Users } from '../components/Icons.jsx';

export default function Ucatsen() {
  return (
    <>
      <div className="page-head">
        <div className="kicker" style={{ color: 'var(--accent)', textTransform: 'uppercase', letterSpacing: '0.12em', fontWeight: 700, fontSize: 12 }}>Access arrangements</div>
        <h1>UCATSEN — extra time on the UCAT</h1>
        <p className="subtitle">For candidates with documented disabilities or specific learning differences. Same test, 25% more time per section.</p>
      </div>

      <section className="card" style={{ marginBottom: 22 }}>
        <h2 style={{ margin: '0 0 8px', fontSize: 20 }}>What is UCATSEN?</h2>
        <p style={{ color: 'var(--text-2)', margin: 0 }}>
          UCATSEN is the official version of the UCAT for candidates who qualify for additional time. The content is identical to the standard UCAT — only the time per section changes (25% extra). Universities treat UCATSEN scores exactly the same as standard UCAT scores when making offers.
        </p>
      </section>

      <h2 style={{ margin: '24px 0 14px', fontSize: 22 }}>Who qualifies</h2>
      <div className="parents-grid">
        <UcatsenCard icon={<FileText />} title="Documented learning difference" body="Dyslexia, dyspraxia, ADHD, or other specific learning differences with a formal assessment by an educational psychologist within the last 4 years." />
        <UcatsenCard icon={<Heart />} title="Physical or sensory disability" body="Conditions that affect reading speed, motor control, or test concentration. Usually with NHS or specialist letter as evidence." />
        <UcatsenCard icon={<Check />} title="Existing school access arrangements" body="If your child already gets extra time on GCSE / A-level exams, they almost certainly qualify for UCATSEN. The documentation overlaps." />
      </div>

      <section className="card" style={{ marginTop: 28 }}>
        <h2 style={{ margin: '0 0 10px', fontSize: 20 }}>How to apply</h2>
        <ol style={{ color: 'var(--text-2)', lineHeight: 1.7, paddingLeft: 22, margin: 0 }}>
          <li><strong>Gather your evidence</strong> — recent psych report or NHS letter, dated within 4 years.</li>
          <li><strong>Book through the UCAT consortium</strong> — when registering, select "UCATSEN" instead of "UCAT".</li>
          <li><strong>Upload supporting documents</strong> in the consortium portal. Decisions usually come within 2 weeks.</li>
          <li><strong>If approved</strong>, the booking system shows you UCATSEN test centres only (same locations, different schedule).</li>
        </ol>
      </section>

      <section className="card" style={{ marginTop: 16 }}>
        <h2 style={{ margin: '0 0 10px', fontSize: 20 }}>Timing on UCATSEN vs UCAT</h2>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              <th style={cellHead}>Section</th>
              <th style={cellHead}>Standard UCAT</th>
              <th style={cellHead}>UCATSEN (+25%)</th>
            </tr>
          </thead>
          <tbody>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              <td style={cell}>Verbal Reasoning</td>
              <td style={cell}>22 min</td>
              <td style={cell}>27 min 30 s</td>
            </tr>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              <td style={cell}>Decision Making</td>
              <td style={cell}>37 min</td>
              <td style={cell}>46 min 15 s</td>
            </tr>
            <tr style={{ borderBottom: '1px solid var(--border)' }}>
              <td style={cell}>Quantitative Reasoning</td>
              <td style={cell}>26 min</td>
              <td style={cell}>32 min 30 s</td>
            </tr>
            <tr>
              <td style={cell}>Situational Judgement</td>
              <td style={cell}>26 min</td>
              <td style={cell}>32 min 30 s</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="parents-cta" style={{ marginTop: 28 }}>
        <div>
          <h2>UCATSEN-aware tutoring</h2>
          <p>Our Medic Mind UCAT tutors include several who took UCATSEN themselves. They know exactly how the extra time changes pacing strategy — and where it doesn't.</p>
        </div>
        <a className="btn" href="https://www.medicmind.co.uk/contact-us/" target="_blank" rel="noreferrer">Book a free call <ArrowRight width="16" height="16" /></a>
      </section>
    </>
  );
}

const cellHead = { padding: '12px 14px', textAlign: 'left', fontSize: 13, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 600 };
const cell = { padding: '12px 14px', fontSize: 15, color: 'var(--text-2)' };

function UcatsenCard({ icon, title, body }) {
  return (
    <div className="parents-card">
      <div className="icon-wrap">{icon}</div>
      <h3>{title}</h3>
      <p>{body}</p>
    </div>
  );
}
